








import Vue, { PropType } from 'vue';
import { BasePeerGroup, MemberRole } from '@/models';
import { groupRoleName } from '@/groupRole';
import RoleSelectorPills, {
  PillConfig
} from '@/components/RoleSelectorPills.vue';

export default Vue.extend({
  components: {
    RoleSelectorPills
  },

  props: {
    activeRoles: Array as PropType<string[]>,
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    }
  },

  computed: {
    rolesConfig(): PillConfig[] {
      return [
        MemberRole.STUDENT,
        MemberRole.TEACHER,
        MemberRole.OBSERVER
      ].map(role => ({ role, roleName: groupRoleName(role, this.peerGroup) }));
    }
  },

  methods: {
    onChange(role: string) {
      this.$emit('role-change', role);
    }
  }
});
